import { render } from "./evaluationDetail.vue?vue&type=template&id=790abbb2&scoped=true"
import script from "./evaluationDetail.vue?vue&type=script&lang=js"
export * from "./evaluationDetail.vue?vue&type=script&lang=js"

import "./evaluationDetail.vue?vue&type=style&index=0&id=790abbb2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790abbb2"]])

export default __exports__